import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addDesignationLevel,
  updateDesignationLevel,
  getDesignationsLevel,
} from "../../actions/userActions/designationLevelAction";
import designationLevelIcon from "../../assets/images/designationLevelIcon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import "./DynamicModal.css";
import BodyExtraSmallMedium from "../designSystem/BodyExtraSmallMedium";
import BodyLargeMedium from "../designSystem/BodyLargeMedium";
import BodySmallRegular from "../designSystem/BodySmallRegular";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Textarea from "../designSystem/TextArea";
import TextField from "../designSystem/TextField";
import { IconButton } from "@mui/material";
import { validateFields } from "../../utils/Validations";
import { Check, X } from "lucide-react";
import Heading6Regular from "../designSystem/Heading6Regular";
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import { t } from "../../locales/translate";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

export const AddDesignationLevel = ({ onClose, editData, onSave }) => {
  const dispatch = useDispatch();
  const initialValues = {
    name: "",
    description: "",
    active: false,
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const designationLevels = useSelector(
    (state) => state.designationLevels_reducer.designationLevels
  );

  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleSave = async (e) => {
  e.preventDefault();
  const errors = validateFields(formValues, 'designationLevel');
  setFormErrors(errors);
  if (Object.keys(errors).length > 0) return;
  
  setLoading(true);
  try {
    if (editData) {
      await dispatch(updateDesignationLevel(formValues));
    } else {
      await dispatch(addDesignationLevel(formValues));
    }
    setLoading(false);
    await onSave(formValues);
  } catch (error) {
    console.error("Error saving designation level:", error);
    setLoading(false);
  }
};
  return (
    <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container overlay-wrapper">
    <LoadingOverlay isVisible={loading} />
    <div className={loading ? 'blur' : ''}>
        <div className="dynamicmodal-header mb-3">
          <div className="dynamicmodal-header-left">
            <div className="icon">
              <img src={designationLevelIcon} alt="designation Level" />
            </div>
            <div className="text">
              <h2 className="modalheading">
                {editData ? "Edit Designation Level" : `${t("addDesignationLevel")}`}
              </h2>
              <p className="modaldescription">
                {t("addDesignationLevelTip")}
              </p>
            </div>
          </div>
          <div className="dynamicmodal-header-right">
            <IconButton onClick={onClose}>
              <img src={closeModal} alt="" />
            </IconButton>
          </div>

        </div>


        <form onSubmit={handleSave}>
          <div className="dynamicmodal-body">
            <div className="mb-2">
            <Heading6Regular
                text={`${t("levelOrder")}: ${editData ? editData.id : designationLevels !== "isLoading" && designationLevels.totalCount + 1}`}
                color="#1E293B"
              />
              <BodySmallMedium
                text={t("lowerNumberHierarchyTip")}
                color="#1E293B"
              />

            </div>
            <TextField
              name="name"
              label={`${t("name")} *`}
              type='text'
              value={formValues.name}
              onChange={handletextChange}
              placeholder={t("name")}
              error={formErrors.name}
            />

            <Textarea
              name="description"
              label={`${t("description")} *`}
              placeholder={t("description")}
              value={formValues.description}
              onChange={handletextChange}
              error={formErrors.description}
            />
            <div className=" mt-2 ml-0">
              <div
                className="form-group"
                style={{ display: "flex", alignItems: "flex-start" }}
              >
                <input
                  name="active"
                  style={{ cursor: "pointer", height: "14px", width: "14px" }}
                  type="checkbox"
                  checked={formValues.active}
                  className="ml-1 mt-1"
                  onChange={handleChange}
                />
                <label
                  style={{ paddingLeft: "5px" }}
                  className="form-control-label"
                >
                  <div style={{ padding: '2px' }}>
                  <p className="button-text">{t("active")}</p>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div className="dynamicmodal-footer">
            <CancelButton
             onClick={onClose}
             text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
             />
            <PrimaryButton
            text={t("save")}
            icon={Check}
            width={document.body.dir === "rtl" ? "123px" : ""}
            />
          </div>
        </form>
      </div>
    </div>
    </div>
  );
};

export default AddDesignationLevel;
